import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/apiClient';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      const response = await apiClient.post('/auth/forgot-password', { email });
      setSuccess('Password reset email has been sent. Please check your inbox and spam folder.');
      setEmail('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send password reset email. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center" style={{ minHeight: '100vh', padding: '3rem 1.5rem' }}>
      <div style={{ maxWidth: '28rem', margin: '0 auto', width: '100%' }}>
        <h2 className="text-3xl font-bold text-center mb-2">
          Reset Your Password
        </h2>
        <p className="text-center mb-6 text-gray-600">
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </div>

      <div style={{ maxWidth: '28rem', margin: '2rem auto 0', width: '100%' }}>
        <div className="card">
          {success ? (
            <div className="p-6 text-center">
              <div className="mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-green-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Email Sent!</h3>
              <p className="mb-6">{success}</p>
              <div className="mt-6">
                <Link 
                  to="/login" 
                  className="text-blue-600 hover:underline"
                >
                  Return to login page
                </Link>
              </div>
            </div>
          ) : (
            <form className="form" onSubmit={handleSubmit}>
              {error && (
                <div style={{ backgroundColor: '#FEE2E2', padding: '1rem', borderRadius: '0.375rem', marginBottom: '1.5rem' }}>
                  <p style={{ color: '#B91C1C', fontSize: '0.875rem', fontWeight: '500' }}>{error}</p>
                </div>
              )}

              <div className="form-group">
                <label htmlFor="email" className="form-label">
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={handleChange}
                    className="form-input"
                  />
                </div>
              </div>

              <div className="mt-4">
                <button
                  type="submit"
                  disabled={isLoading}
                  className={`btn text-smd btn-primary ${isLoading ? 'btn-disabled' : ''}`}
                  style={{ width: '100%' }}
                >
                  {isLoading ? 'Sending...' : 'Send Reset Link'}
                </button>
              </div>
            </form>
          )}

          <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
            <Link 
              to="/login" 
              style={{ 
                fontWeight: '500', 
                color: 'var(--color-primary)',
                textDecoration: 'none'
              }}
            >
              Back to login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 